var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { connect } from "react-redux";
import { selectActiveTutorialComponent } from "../../../selectors/selectTutorial";
var DialogTutorialDOM = /** @class */ (function (_super) {
    __extends(DialogTutorialDOM, _super);
    function DialogTutorialDOM() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DialogTutorialDOM.prototype.render = function () {
        var _a = this.props, TutorialComponent = _a.TutorialComponent, shouldRender = _a.shouldRender;
        if (TutorialComponent === undefined || !shouldRender) {
            // tslint:disable-next-line:no-null-keyword
            return null;
        }
        return React.createElement(TutorialComponent, null);
    };
    return DialogTutorialDOM;
}(React.Component));
var mapState = function (state) {
    var Component = selectActiveTutorialComponent(state);
    var shouldRender = state.errors.UnhandledErrors.length === 0;
    return {
        TutorialComponent: Component,
        shouldRender: shouldRender,
    };
};
export var DialogTutorial = connect(mapState)(DialogTutorialDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/components/DialogTutorial.tsx
// module id = 1374
// module chunks = 3